import React from 'react'
import { Trash, X } from '@phosphor-icons/react'

const ModalDeleteContent = ({ open, onClose, onDelete, content }) => {
  return (
    <div>

      <dialog className={`modal ${open ? 'modal-open' : ''}`}>
        <div className="modal-box">
          <h3 className="font-bold text-lg">Confirm Deletion</h3>
          <p className="py-4">Are you sure you want to delete <span
            className="font-bold">{content?.title}</span> ? This action cannot
            be undone.</p>
          <div className="modal-action">
            <button className="btn btn-xs btn-outline" onClick={onClose}>
              <span className="mr-2">Cancel</span>
              <X size={16}/>
            </button>
            <button className="btn btn-xs btn-error btn-outline"
                    onClick={() => {
                      onDelete()
                      onClose()
                    }}>
              <span className="mr-2">Delete</span>
              <Trash size={16}/>
            </button>
          </div>
        </div>
        <form method="dialog" className="modal-backdrop" onClick={onClose}>
          <button>close</button>
        </form>
      </dialog>
    </div>
  )
}

export default ModalDeleteContent